const TEAMROOM_LOCALE_TEMPLATES = {
    "en": {
        "teamroom.nav.vacancies": "Vacancies",
        "teamroom.common.close": "Close",
        "teamroom.common.back": "Back",

        "teamroom.header.howItWorks.aria": "How does welovehumans work?",
        "teamroom.header.profile.alt": "Profile",
        "teamroom.header.logOut": "Log out",

        "teamroom.support.title": "What can we help you with?",
        "teamroom.support.message": "Your message",
        "teamroom.support.placeholder": "Ask us anything and we will get back to you asap",
        "teamroom.support.send": "Send",

        "teamroom.notifications.title": "Notifications",
        "teamroom.notifications.empty": "You're all caught up",
        "teamroom.notifications.emptyHint": "New updates about your vacancies and candidates will appear here.",
        "teamroom.notifications.unread": "{count} unread",

        "teamroom.howItWorks.title": "How does welovehumans work?",
        "teamroom.howItWorks.intro": "From vacancy to results in three steps — you train Lucy, she runs the interviews.",
        "teamroom.howItWorks.step1.title": "Create a vacancy",
        "teamroom.howItWorks.step1.body": "Give Lucy your vacancy — a link, text or a file — and she fills in the rest for you.",
        "teamroom.howItWorks.step2.title": "Build the interview",
        "teamroom.howItWorks.step2.body": "Lucy writes the questions tailored to your vacancy — you adjust them, with optional conditions per question and extra languages if you want.",
        "teamroom.howItWorks.step3.title": "Share the link",
        "teamroom.howItWorks.step3.body": "Put the application link on your job posting or socials, or send it straight to candidates — they start the interview with Lucy right away, no account needed.",
        "teamroom.howItWorks.faqTitle": "Frequently asked questions",
        "teamroom.howItWorks.faq1.q": "How do I compose the interview?",
        "teamroom.howItWorks.faq1.a": "In the Interview tab of a vacancy you add sections (text or questions) and your questions below them, optionally with sub-questions. Everything you type is saved automatically.",
        "teamroom.howItWorks.faq2.q": "Can I make questions conditional?",
        "teamroom.howItWorks.faq2.a": "Yes. Per question you set 'only ask if…' or 'skip if…'. Lucy reads that as an instruction during the interview.",
        "teamroom.howItWorks.faq3.q": "How do I invite candidates?",
        "teamroom.howItWorks.faq3.a": "Every vacancy has its own application link (Share button). Put it on your job posting or socials, or send it straight to candidates. They just fill in their name, email and phone number, and then start the interview with Lucy right away — no account needed.",
        "teamroom.howItWorks.faq5.q": "Can the interview be in multiple languages?",
        "teamroom.howItWorks.faq5.a": "Yes. Add an additional language to the vacancy — Lucy translates or generates the interview per language, and the candidate picks their language when starting.",
        "teamroom.howItWorks.faq4.q": "What does a candidate need?",
        "teamroom.howItWorks.faq4.a": "Just their name, an email address and a few minutes — no account needed. Lucy has a short interview with them of about 10 minutes.",
        "teamroom.howItWorks.footer.text": "Another question? Our team is happy to help. ",
        "teamroom.howItWorks.footer.cta": "Ask your question",

        "teamroom.vacancyStatus.open": "Active",
        "teamroom.vacancyStatus.filled": "Paused",
        "teamroom.vacancyStatus.concept": "Draft",
        "teamroom.vacancyStatus.withdrawn": "Withdrawn",

        "teamroom.time.today": "today",
        "teamroom.time.yesterday": "yesterday",
        "teamroom.time.daysAgo": "{days} days ago",
        "teamroom.time.weeksAgo": "{weeks, plural, one {# week} other {# weeks}} ago",

        "teamroom.hero.greeting.night": "Good night",
        "teamroom.hero.greeting.morning": "Good morning",
        "teamroom.hero.greeting.afternoon": "Good afternoon",
        "teamroom.hero.greeting.evening": "Good evening",
        "teamroom.hero.mascot.morning": "Ready for the day?",
        "teamroom.hero.mascot.afternoon": "Nice to see you!",
        "teamroom.hero.mascot.evening": "Glad you're here!",
        "teamroom.hero.newVacancy": "New vacancy",

        "teamroom.overview.heading.all": "All roles",
        "teamroom.overview.heading.active": "Active roles",
        "teamroom.overview.heading.paused": "Paused roles",
        "teamroom.overview.heading.concept": "Drafts",
        "teamroom.overview.search": "Search",
        "teamroom.overview.searchPlaceholder": "Search by role, company or location",
        "teamroom.overview.empty.title": "No roles found",
        "teamroom.overview.empty.body": "Adjust your search to find roles.",
        "teamroom.overview.empty.clear": "Clear",

        "teamroom.filter.label": "Filter by",
        "teamroom.filter.option.all": "All",
        "teamroom.filter.option.active": "Active",
        "teamroom.filter.option.paused": "Paused",
        "teamroom.filter.option.concept": "Draft",

        "teamroom.vacancyCard.untitled": "Untitled role",
        "teamroom.vacancyCard.updated": "updated {time}",
        "teamroom.vacancyCard.fallback": "vacancy",

        "teamroom.common.loading": "Loading…",
        "teamroom.common.cancel": "Cancel",
        "teamroom.common.delete": "Delete",

        "teamroom.candidates.title": "Candidates",
        "teamroom.candidates.export": "Export",
        "teamroom.candidates.loading": "Loading results…",
        "teamroom.candidates.empty": "No candidates yet. As soon as someone responds via the application link, they will appear here — with Lucy's advice once the interview is completed.",
        "teamroom.candidates.loadError": "The candidates could not be loaded — please try again later.",
        "teamroom.candidates.filteredEmpty": "No candidates within the selected filters.",
        "teamroom.candidates.col.candidate": "Candidate",
        "teamroom.candidates.col.date": "Date",
        "teamroom.candidates.col.advice": "Advice",
        "teamroom.candidates.rec.proceed": "Recommended",
        "teamroom.candidates.rec.reject": "Not recommended",
        "teamroom.candidates.status.processing": "Analysing",
        "teamroom.candidates.status.notStarted": "Not started yet",
        "teamroom.candidates.status.done": "Completed",
        "teamroom.candidates.adviceFilter.all": "All advice",
        "teamroom.candidates.adviceFilter.pending": "Pending",
        "teamroom.candidates.dateFilter.all": "All time",
        "teamroom.candidates.dateFilter.last7days": "Past 7 days",
        "teamroom.candidates.dateFilter.lastMonth": "Past month",
        "teamroom.candidates.dateFilter.period": "Period",
        "teamroom.candidates.csv.name": "Name",
        "teamroom.candidates.csv.email": "Email",
        "teamroom.candidates.csv.phone": "Phone number",
        "teamroom.candidates.csv.date": "Date",
        "teamroom.candidates.csv.advice": "Advice",
        "teamroom.candidates.csv.reason": "Explanation",
        "teamroom.candidates.csvFileName": "candidates",

        "teamroom.vacancy.tab.candidates": "Candidates",
        "teamroom.vacancy.tab.interview": "Interview",
        "teamroom.vacancy.tab.settings": "Settings",
        "teamroom.vacancy.notFound": "This vacancy no longer exists.",
        "teamroom.vacancy.backToOverview": "Back to overview",
        "teamroom.vacancy.backToLucy": "back to Lucy",
        "teamroom.vacancy.ratingScore": "Candidates rate this interview {score}",
        "teamroom.vacancy.ratingCount": "{count, plural, one {# review} other {# reviews}}",
        "teamroom.vacancy.ratingTooFew": "Not enough reviews yet to show a score",
        "teamroom.vacancy.ratingNone": "No candidate reviews yet",
        "teamroom.vacancy.actions.testInterview": "Test interview",
        "teamroom.vacancy.actions.share": "Share application link",
        "teamroom.vacancy.actions.more": "More actions",
        "teamroom.vacancy.actions.activate": "Activate role",
        "teamroom.vacancy.actions.pause": "Pause role",
        "teamroom.vacancy.actions.delete": "Delete role",
        "teamroom.vacancy.deleteConfirm.title": "Delete role?",
        "teamroom.vacancy.deleteConfirm.body": "\"{title}\" will be removed from your active roles. You can reactivate it later.",

        "teamroom.share.title": "Share the application link",
        "teamroom.share.body": "Put it on your job posting or send it to candidates — they start the interview with Lucy right away, no account needed.",
        "teamroom.share.linkLabel": "Application link",
        "teamroom.share.copy": "copy link",
        "teamroom.share.copied": "copied!",
        "teamroom.share.openApplyPage": "Open the apply page",
        "teamroom.share.metaAds.title": "Apply via WhatsApp",
        "teamroom.share.metaAds.description": "Paste the ad id of your click-to-WhatsApp ad here. Candidates who message through that ad automatically receive the link to the introduction interview.",
        "teamroom.share.metaAds.placeholder": "Ad id, separate several with commas",
        "teamroom.share.metaAds.error": "This ad id is already linked to another vacancy.",
        "teamroom.share.metaAds.saveError": "Saving failed, please try again.",
        "teamroom.share.metaAds.unlinked.title": "Ads not linked yet",
        "teamroom.share.metaAds.unlinked.messages": "{count, plural, one {# message} other {# messages}}",
        "teamroom.share.metaAds.unlinked.link": "Link to this vacancy",
        "teamroom.share.metaAds.unlinked.hint": "After creating or editing your ad, tap its preview once yourself; the id then appears here.",
        "teamroom.share.metaAds.unlinked.linked": "Linked.",
        "teamroom.share.metaAds.unlinked.linkedWithReplies": "Linked. {count, plural, one {# candidate gets} other {# candidates get}} the message after all.",

        "teamroom.candidatePage.headline.proceed": "Lucy recommends proceeding",
        "teamroom.candidatePage.headline.reject": "Lucy recommends not proceeding",
        "teamroom.candidatePage.headline.processing": "Lucy is analysing the interview",
        "teamroom.candidatePage.headline.unavailable": "No advice available",
        "teamroom.candidatePage.headline.pending": "No interview held yet",
        "teamroom.candidatePage.label.unavailable": "Unavailable",
        "teamroom.candidatePage.fallback.processing": "The interview is complete. Lucy is working on her advice — check back in a little while.",
        "teamroom.candidatePage.fallback.unavailable": "The analysis could not be completed. The interview remains available below.",
        "teamroom.candidatePage.fallback.pending": "Once the interview with Lucy has taken place, the advice and motivation will appear here.",
        "teamroom.candidatePage.loadError": "This candidate could not be loaded.",
        "teamroom.candidatePage.backToVacancy": "Back to the vacancy",
        "teamroom.candidatePage.vacancyFallback": "Vacancy",
        "teamroom.candidatePage.candidateFallback": "Candidate",
        "teamroom.candidatePage.copied": "Copied",
        "teamroom.candidatePage.copyAria": "Copy {value}",
        "teamroom.candidatePage.nameCopied": "Name copied",
        "teamroom.candidatePage.cv.button": "CV",
        "teamroom.candidatePage.cv.title": "CV of {name}",
        "teamroom.candidatePage.cv.loading": "Loading CV…",
        "teamroom.candidatePage.cv.loadError": "The CV could not be loaded. Please try again later.",
        "teamroom.candidatePage.cv.previewError": "The CV could not be displayed. You can still download it.",
        "teamroom.candidatePage.cv.download": "Download CV",
        "teamroom.candidatePage.readMore": "Read more",
        "teamroom.candidatePage.readLess": "Read less",
        "teamroom.candidatePage.meta.minutes": "{duration} min",
        "teamroom.candidatePage.meta.questions": "{count} questions",

        "teamroom.transcript.title": "The interview",
        "teamroom.transcript.audioUnavailable": "Audio unavailable",
        "teamroom.transcript.empty": "No transcript yet. Once {firstName} has had the interview with Lucy, you can read it back here.",
        "teamroom.transcript.follow": "Follow the conversation",
        "teamroom.transcript.unintelligible": "[unintelligible]",

        "teamroom.player.back10": "10 seconds back",
        "teamroom.player.forward10": "10 seconds forward",
        "teamroom.player.play": "Play",
        "teamroom.player.pause": "Pause",

        "teamroom.settings.title": "Settings",
        "teamroom.settings.firstName": "First name",
        "teamroom.settings.lastName": "Last name",
        "teamroom.settings.changePassword": "Change password",
        "teamroom.settings.passwordUpdated": "Your password has been updated.",
        "teamroom.settings.retry": "Try again",
        "teamroom.settings.verified": "Verified",
        "teamroom.settings.uploadLogo": "Upload logo",
        "teamroom.settings.imageTypeError": "Choose a JPG or PNG image.",
        "teamroom.settings.backgroundHint": "Choose what candidates see behind Lucy during the interview.",
        "teamroom.settings.companyColor": "Company colour",
        "teamroom.settings.backgroundImage": "Image",
        "teamroom.settings.uploadBackground": "Upload custom background",
        "teamroom.settings.removeBackground": "Remove custom background",
        "teamroom.settings.backgroundFocus": "Background focus point",
        "teamroom.settings.backgroundFocusHint": "Drag the frame to the part of the image that should stay visible on mobile screens.",
        "teamroom.settings.tab.account": "Account",
        "teamroom.settings.tab.company": "Company Settings",
        "teamroom.settings.tab.interview": "Interview",
        "teamroom.settings.tab.integrations": "Integrations",
        "teamroom.settings.tab.users": "Users",
        "teamroom.settings.name": "Name",
        "teamroom.settings.email": "Email",
        "teamroom.settings.emailChangeHint": "Need to change your email address? {support}",
        "teamroom.settings.emailChangeSupport": "Contact support",
        "teamroom.settings.mobileNumber": "Mobile number",
        "teamroom.settings.company": "Company",
        "teamroom.settings.location": "Location",
        "teamroom.settings.calendar": "Calendar",
        "teamroom.settings.firstNamePlaceholder": "*First name not yet specified",
        "teamroom.settings.lastNamePlaceholder": "*Last name not yet specified",
        "teamroom.settings.notSpecifiedPlaceholder": "*Not yet specified",
        "teamroom.settings.password": "Password",
        "teamroom.settings.currentPassword": "Current password",
        "teamroom.settings.newPassword": "New password",
        "teamroom.settings.repeatNewPassword": "Repeat new password",
        "teamroom.settings.passwordsRequired": "New password and repeated password are required",
        "teamroom.settings.passwordsDontMatch": "Passwords do not match",
        "teamroom.settings.saveChanges": "Save changes",
        "teamroom.settings.unsavedChanges": "You have unsaved changes, are you sure you want to leave?",
        "teamroom.settings.ok": "OK",
        "teamroom.settings.companySettings": "Interview settings",
        "teamroom.settings.interview.preview.desktop": "Desktop",
        "teamroom.settings.interview.preview.mobile": "Mobile",
        "teamroom.settings.interview.preview.apply": "Application page",
        "teamroom.settings.interview.preview.caption": "Tell me a bit about yourself…",
        "teamroom.settings.companyDescription": "Company description",
        "teamroom.settings.brandColor": "Brand colour",
        "teamroom.settings.brandColorInvalid": "Enter a colour like #4598B1.",

        "teamroom.settings.whatsapp": "WhatsApp",
        "teamroom.settings.whatsapp.description": "Connect your company's WhatsApp, so Lucy can send candidates their interview link and reminders in your name.",
        "teamroom.settings.whatsapp.connect": "Connect WhatsApp",
        "teamroom.settings.whatsapp.connected": "Connected",
        "teamroom.settings.whatsapp.status.checking": "Checking status…",
        "teamroom.settings.whatsapp.status.ready": "Ready to send",
        "teamroom.settings.whatsapp.status.notReady": "Not ready to send",
        "teamroom.settings.whatsapp.status.waitingForApproval": "Waiting for approval",
        "teamroom.settings.whatsapp.status.inactive": "Inactive",
        "teamroom.settings.whatsapp.status.unavailable": "Unable to check status",
        "teamroom.settings.whatsapp.status.refresh": "Refresh status",
        "teamroom.settings.whatsapp.status.retry": "Try again",
        "teamroom.settings.whatsapp.status.displayNameNotApproved": "Meta has not approved your WhatsApp display name. Check its status in WhatsApp Manager.",
        "teamroom.settings.whatsapp.status.phoneNumberNotConnected": "Your WhatsApp phone number is not connected. Check its status in WhatsApp Manager.",
        "teamroom.settings.whatsapp.billingNote": "Meta bills message costs directly to your company (about €0.05 per reminder).",
        "teamroom.settings.whatsapp.reconnect": "Reconnect",
        "teamroom.settings.whatsapp.cancelled": "The connection was cancelled before it finished.",
        "teamroom.settings.whatsapp.error": "Connecting WhatsApp failed — please try again.",
        "teamroom.settings.whatsapp.templates": "Messages",
        "teamroom.settings.whatsapp.templates.description": "These messages are sent automatically on your behalf via WhatsApp.",
        "teamroom.settings.whatsapp.templates.reminder1": "Reminder 1",
        "teamroom.settings.whatsapp.templates.reminder1.timing": "15 minutes after applying",
        "teamroom.settings.whatsapp.templates.reminder2": "Reminder 2",
        "teamroom.settings.whatsapp.templates.reminder2.timing": "24 hours after applying",
        "teamroom.settings.whatsapp.templates.reminder2.toggle": "Send reminder 2",
        "teamroom.settings.whatsapp.templates.reminder2.toggleError": "The setting could not be saved — please try again.",
        "teamroom.settings.whatsapp.templates.status.active": "Active",
        "teamroom.settings.whatsapp.templates.status.pending": "In review",
        "teamroom.settings.whatsapp.templates.status.rejected": "Rejected",
        "teamroom.settings.whatsapp.templates.status.paused": "Paused",
        "teamroom.settings.whatsapp.templates.refresh": "Refresh status",
        "teamroom.settings.whatsapp.templates.edit": "Edit",
        "teamroom.settings.whatsapp.templates.editor.body": "Message",
        "teamroom.settings.whatsapp.templates.editor.buttonText": "Button text",
        "teamroom.settings.whatsapp.templates.editor.insert.first_name": "First name",
        "teamroom.settings.whatsapp.templates.editor.insert.vacancy_title": "Vacancy",
        "teamroom.settings.whatsapp.templates.editor.insert.company_name": "Company",
        "teamroom.settings.whatsapp.templates.editor.submit": "Save and submit for approval",
        "teamroom.settings.whatsapp.templates.editor.note": "We keep sending the current version until Meta approves the new one.",
        "teamroom.settings.whatsapp.templates.editor.error.body_required": "Write a message first.",
        "teamroom.settings.whatsapp.templates.editor.error.body_too_long": "The message is too long — 1024 characters at most.",
        "teamroom.settings.whatsapp.templates.editor.error.unknown_field": "Only the fields below can be used in the message.",
        "teamroom.settings.whatsapp.templates.editor.error.field_at_edge": "The message cannot start or end with a field.",
        "teamroom.settings.whatsapp.templates.editor.error.adjacent_fields": "Two fields cannot follow each other — put a word in between.",
        "teamroom.settings.whatsapp.templates.editor.error.button_text_required": "Fill in the button text.",
        "teamroom.settings.whatsapp.templates.editor.error.button_text_too_long": "The button text is too long — 25 characters at most.",
        "teamroom.settings.whatsapp.templates.editor.error.generic": "Saving failed — please try again.",
        "teamroom.settings.whatsapp.templates.error": "The messages could not be loaded — please try again later.",
        "teamroom.settings.interviewBackground": "Interview background",
        "teamroom.settings.companyLogo": "Company logo",
        "teamroom.settings.profileImage": "Profile image",
        "teamroom.settings.verify": "Verify",
        "teamroom.settings.confirm": "Confirm",
        "teamroom.settings.verifyCodeInstruction": "Enter the 6-digit code that you have received",
        "teamroom.settings.tooltip.invalidLocation": "A valid location is required",
        "teamroom.settings.tooltip.invalidPhone": "A valid phone number is required",
        "teamroom.settings.tooltip.changeRequired": "Change something before saving",
        "teamroom.settings.tooltip.companyDescriptionMissing": "Please fill in Company description",
        "teamroom.builder.langTab.generating": "Lucy is working on this interview…",
        "teamroom.builder.langTab.translating": "Translating…",
        "teamroom.builder.langTab.translateError": "Translating this interview didn't work. Try again, or build it yourself below.",
        "teamroom.builder.langTab.retry": "Try again",
        "teamroom.builder.langTab.unsaved": "Save or undo your changes before switching languages.",
        "teamroom.builder.langTab.notGenerated": "This interview doesn't exist in this language yet. Build it yourself below, or have Lucy translate the questions from your existing interview.",
        "teamroom.builder.langTab.generateButton": "Have Lucy translate it",
        "teamroom.builder.loadFailed": "The interview could not be loaded. Please try again.",

        "teamroom.settings.language": "Language",

        "teamroom.builder.loading": "Loading the interview…",
        "teamroom.builder.saveFailed": "Your changes could not be saved. Please try again.",
        "teamroom.builder.validationModal.title": "Interview not complete yet",
        "teamroom.builder.validationModal.continueEditing": "Continue editing",
        "teamroom.builder.heading": "The interview",
        "teamroom.builder.status.saved": "saved",
        "teamroom.builder.status.lucyUpdated": "Lucy is up to date",
        "teamroom.builder.status.saving": "saving…",
        "teamroom.builder.status.unsaved": "not saved yet",
        "teamroom.builder.undo": "Undo",
        "teamroom.builder.edit": "Edit",
        "teamroom.builder.done": "Done",
        "teamroom.builder.publishUpdates": "Put updates live",
        "teamroom.builder.addSection": "Add section",
        "teamroom.builder.sectionType.text": "Text",
        "teamroom.builder.sectionType.questions": "Questions",
        "teamroom.builder.fixed": "fixed",
        "teamroom.builder.greetingPreview": "Hi [CANDIDATE NAME].",
        "teamroom.builder.empty.title": "Let's build the interview",
        "teamroom.builder.empty.body": "Start with an intro, add your questions and close on a warm note.",
        "teamroom.builder.guard.title": "Save changes?",
        "teamroom.builder.guard.body": "You have changes queued that are not live yet. Save them before you continue, or continue without saving.",
        "teamroom.builder.guard.keepEditing": "Keep editing",
        "teamroom.builder.guard.discard": "Don't save",
        "teamroom.builder.guard.save": "Save",
        "teamroom.builder.validation.noSections": "Add at least one section before putting the changes live.",
        "teamroom.builder.validation.titleRequired": "Every section needs a title.",
        "teamroom.builder.validation.questionRequired": "A question is required for every text section that is followed by another section, so the candidate has a clear moment to respond.",
        "teamroom.builder.validation.contentRequired": "Fill in the content of every section.",
        "teamroom.builder.nav.title": "In this interview",
        "teamroom.builder.nav.textSection": "Text section",
        "teamroom.builder.nav.questionBlock": "Question block",
        "teamroom.builder.questionPlaceholder": "Write the question here…",
        "teamroom.builder.moveUp": "Move up",
        "teamroom.builder.moveDown": "Move down",
        "teamroom.builder.deleteQuestion": "Delete question",
        "teamroom.builder.deleteSection": "Delete section",
        "teamroom.builder.generating.title": "Lucy is putting your interview together…",
        "teamroom.builder.generating.phase1": "Reading the vacancy text…",
        "teamroom.builder.generating.phase2": "Identifying competencies…",
        "teamroom.builder.generating.phase3": "Coming up with questions…",
        "teamroom.builder.generating.phase4": "Building the interview…",
        "teamroom.builder.condition.ask.label": "Only ask if…",
        "teamroom.builder.condition.ask.placeholder": "E.g. only if the candidate mentions experience with Zendesk",
        "teamroom.builder.condition.skip.label": "Skip if…",
        "teamroom.builder.condition.skip.placeholder": "E.g. not based in the Netherlands",
        "teamroom.builder.setup.short.label": "Short interview",
        "teamroom.builder.setup.short.desc": "A quick introduction — a few focused core questions.",
        "teamroom.builder.setup.long.label": "In-depth interview",
        "teamroom.builder.setup.long.desc": "A thorough interview — more questions with natural follow-ups.",
        "teamroom.builder.setup.aiQuestions": "Questions by AI",
        "teamroom.builder.setup.blank.label": "Or start with a blank setup",
        "teamroom.builder.setup.blank.desc": "Start empty and build the intro + questions yourself.",
        "teamroom.builder.section.titlePlaceholder.content": "Title of this section",
        "teamroom.builder.section.titlePlaceholder.questions": "Name of this block",
        "teamroom.builder.section.titleRequired": "A section title is required",
        "teamroom.builder.section.textPlaceholder": "Write here exactly what Lucy will say…",
        "teamroom.builder.section.addQuestion": "Add question",
        "teamroom.builder.section.addOptionalQuestion": "Add optional question",
        "teamroom.builder.section.questionRequired": "A question is required so the candidate has a clear moment to respond",
        "teamroom.builder.section.questionPlaceholder": "One question for this section…",
        "teamroom.builder.section.removeQuestion": "Remove question",
        "teamroom.builder.tree.empty": "No questions yet. Add your first main question.",
        "teamroom.builder.tree.addMain": "Add main question",
        "teamroom.builder.tree.addSub": "Add sub-question",
        "teamroom.vacancyForm.jobTitle": "Job title",
        "teamroom.vacancyForm.jobTitlePlaceholder": "e.g. Customer Service Agent",
        "teamroom.vacancyForm.companyName": "Company name",
        "teamroom.vacancyForm.companyNamePlaceholder": "e.g. welovehumans",
        "teamroom.vacancyForm.location": "Location",
        "teamroom.vacancyForm.interviewLanguage": "Interview language",
        "teamroom.vacancyForm.additionalLanguages": "Other languages",
        "teamroom.vacancyForm.noAdditionalLanguage": "No additional language",
        "teamroom.vacancyForm.jobDescription": "Vacancy text",
        "teamroom.vacancyForm.language.nl": "Dutch",
        "teamroom.vacancyForm.language.en": "English",
        "teamroom.vacancySettings.title": "Vacancy",
        "teamroom.vacancySettings.edit": "Edit",
        "teamroom.vacancySettings.editTitle": "Edit vacancy",
        "teamroom.vacancySettings.country": "Country",
        "teamroom.vacancySettings.save": "Save",
        "teamroom.vacancySettings.saveError": "Saving failed — please try again in a moment.",

        "teamroom.wizard.step.infer.bubble": "what's the role?",
        "teamroom.wizard.step.validate.bubble": "does this fit?",
        "teamroom.wizard.step.generate.bubble": "now the interview!",
        "teamroom.wizard.nav.next": "Next",
        "teamroom.wizard.nav.back": "Back",
        "teamroom.wizard.nav.generate": "Generate questions",
        "teamroom.wizard.nav.startTraining": "Start training",
        "teamroom.wizard.stepCount": "Step {current} of {total}",
        "teamroom.wizard.loadingConcept": "Loading your draft…",
        "teamroom.wizard.deleteConcept.title": "Delete draft?",
        "teamroom.wizard.deleteConcept.body": "\"{title}\" will be removed from your drafts.",
        "teamroom.wizard.deleteConcept.action": "Delete draft",
        "teamroom.wizard.infer.title": "What am I training on?",
        "teamroom.wizard.infer.intro": "Give me the vacancy — a link, the text, or a file. I'll fill in the rest myself.",
        "teamroom.wizard.infer.phase.reading": "Reading the vacancy text…",
        "teamroom.wizard.infer.phase.filling": "Filling in the details…",
        "teamroom.wizard.infer.phase.saving": "Saving your draft…",
        "teamroom.wizard.infer.error": "That didn't work — check the link or paste the text, and try again.",
        "teamroom.wizard.validate.title": "We've given it a head start",
        "teamroom.wizard.validate.intro": "Give it a quick check and fill in any gaps.",
        "teamroom.wizard.validate.saveError": "Something went wrong while saving — please try again in a moment.",
        "teamroom.wizard.generate.title": "What kind of interview will it be?",
        "teamroom.wizard.generate.intro": "Choose a setup — Lucy writes the questions with AI, tailored to your vacancy.",
        "teamroom.wizard.generate.error": "Generating didn't work — please try again in a moment.",
        "teamroom.wizard.source.tab.url": "Link",
        "teamroom.wizard.source.tab.file": "File",
        "teamroom.wizard.source.tab.text": "Text",
        "teamroom.wizard.source.urlPlaceholder": "https://yourcompany.com/vacancies/...",
        "teamroom.wizard.source.urlHint": "Paste the link to the vacancy — I'll extract the text myself.",
        "teamroom.wizard.source.textPlaceholder": "Paste or type the vacancy text — what will you be doing, which skills matter?",
        "teamroom.wizard.source.removeFile": "Remove file",
        "teamroom.wizard.source.drop": "Drag your document here or {browse}",
        "teamroom.wizard.source.browse": "browse",
        "teamroom.wizard.source.fileTypes": "PDF or Word (.pdf, .docx)",
        "teamroom.wizard.source.fileTypeError": "Upload a PDF or Word document (.pdf or .docx).",
        "teamroom.wizard.alwaysOn.title": "24/7 — always available",
        "teamroom.wizard.alwaysOn.subtitle": "Lucy conducts interviews day and night.",
        "teamroom.wizard.alwaysOn.statusOn": "Lucy is switched on — she takes every interview, day and night.",
        "teamroom.wizard.alwaysOn.statusOff": "Lucy can't wait to get started — give her the go-ahead.",
        "teamroom.wizard.completion.title.on": "Lucy is on 24/7",
        "teamroom.wizard.completion.title.off": "Lucy is trained and ready to go",
        "teamroom.wizard.completion.subtitle.on": "Share the link and the interviews will come flooding in.",
        "teamroom.wizard.completion.subtitle.off": "One tap and she'll get to work for you day and night.",
        "teamroom.wizard.completion.activateError": "Activating didn't work — please try again in a moment.",
        "teamroom.wizard.completion.copy": "Copy",
        "teamroom.wizard.completion.copied": "Copied",
        "teamroom.wizard.completion.toInterviewPage": "Go to interview page",
        "teamroom.wizard.training.phase1": "Training Lucy…",
        "teamroom.wizard.training.phase2": "Setting up the interview…",
        "teamroom.wizard.training.phase3": "Loading the questions…",
        "teamroom.wizard.training.phase4": "Almost done…",
        "teamroom.createVacancy.cityPlaceholder": "e.g. Amsterdam",
        "teamroom.createVacancy.jobDescriptionPlaceholder": "Paste the vacancy text here so you have it at hand while building the interview.",
    },
    "nl": {
        "teamroom.nav.vacancies": "Vacatures",
        "teamroom.common.close": "Sluiten",
        "teamroom.common.back": "Terug",

        "teamroom.header.howItWorks.aria": "Hoe werkt welovehumans?",
        "teamroom.header.profile.alt": "Profiel",
        "teamroom.header.logOut": "Uitloggen",

        "teamroom.support.title": "Waar kunnen we je mee helpen?",
        "teamroom.support.message": "Je bericht",
        "teamroom.support.placeholder": "Stel je vraag en we komen er zo snel mogelijk bij je op terug",
        "teamroom.support.send": "Versturen",

        "teamroom.notifications.title": "Notificaties",
        "teamroom.notifications.empty": "Je bent helemaal bij",
        "teamroom.notifications.emptyHint": "Nieuwe updates over je vacatures en kandidaten verschijnen hier.",
        "teamroom.notifications.unread": "{count} ongelezen",

        "teamroom.howItWorks.title": "Hoe werkt welovehumans?",
        "teamroom.howItWorks.intro": "In drie stappen van vacature naar resultaten — jij traint Lucy, zij voert de gesprekken.",
        "teamroom.howItWorks.step1.title": "Maak een vacature aan",
        "teamroom.howItWorks.step1.body": "Geef Lucy je vacature — een link, tekst of bestand — en ze vult de rest zelf voor je in.",
        "teamroom.howItWorks.step2.title": "Bouw het gesprek",
        "teamroom.howItWorks.step2.body": "Lucy schrijft de vragen op maat van je vacature — jij past ze aan, met optionele voorwaarden per vraag en extra talen als je wilt.",
        "teamroom.howItWorks.step3.title": "Deel de link",
        "teamroom.howItWorks.step3.body": "Zet de sollicitatielink op je vacature of socials, of stuur 'm direct naar kandidaten — ze starten direct het gesprek met Lucy, zonder account.",
        "teamroom.howItWorks.faqTitle": "Veelgestelde vragen",
        "teamroom.howItWorks.faq1.q": "Hoe stel ik het interview samen?",
        "teamroom.howItWorks.faq1.a": "In de Interview-tab van een vacature voeg je secties toe (tekst of vragen) en daaronder je vragen, eventueel met subvragen. Alles wat je typt slaat automatisch op.",
        "teamroom.howItWorks.faq2.q": "Kan ik vragen voorwaardelijk maken?",
        "teamroom.howItWorks.faq2.a": "Ja. Per vraag stel je 'alleen vragen als…' of 'overslaan als…' in. Lucy leest dat als instructie tijdens het gesprek.",
        "teamroom.howItWorks.faq3.q": "Hoe nodig ik kandidaten uit?",
        "teamroom.howItWorks.faq3.a": "Elke vacature heeft een eigen sollicitatielink (knop Delen). Zet 'm op je vacature of socials, of stuur 'm direct naar kandidaten. Zij vullen alleen even hun naam, e-mail en telefoonnummer in en starten daarna direct het gesprek met Lucy — zonder account.",
        "teamroom.howItWorks.faq5.q": "Kan het gesprek in meerdere talen?",
        "teamroom.howItWorks.faq5.a": "Ja. Voeg bij de vacature een extra taal toe — Lucy vertaalt of genereert het gesprek per taal, en de kandidaat kiest bij de start zelf de taal.",
        "teamroom.howItWorks.faq4.q": "Wat heeft een kandidaat nodig?",
        "teamroom.howItWorks.faq4.a": "Alleen z'n naam, e-mailadres en een paar minuten — een account is niet nodig. Lucy neemt een kort gesprek van ongeveer 10 minuten af.",
        "teamroom.howItWorks.footer.text": "Nog een vraag? Ons team helpt je graag verder. ",
        "teamroom.howItWorks.footer.cta": "Stel je vraag",

        "teamroom.vacancyStatus.open": "Actief",
        "teamroom.vacancyStatus.filled": "Gepauzeerd",
        "teamroom.vacancyStatus.concept": "Concept",
        "teamroom.vacancyStatus.withdrawn": "Ingetrokken",

        "teamroom.time.today": "vandaag",
        "teamroom.time.yesterday": "gisteren",
        "teamroom.time.daysAgo": "{days} dagen geleden",
        "teamroom.time.weeksAgo": "{weeks} {weeks, plural, one {week} other {weken}} geleden",

        "teamroom.hero.greeting.night": "Goedenacht",
        "teamroom.hero.greeting.morning": "Goedemorgen",
        "teamroom.hero.greeting.afternoon": "Goedemiddag",
        "teamroom.hero.greeting.evening": "Goedenavond",
        "teamroom.hero.mascot.morning": "Zin in de dag?",
        "teamroom.hero.mascot.afternoon": "Leuk je te zien!",
        "teamroom.hero.mascot.evening": "Fijn dat je er bent!",
        "teamroom.hero.newVacancy": "Nieuwe vacature",

        "teamroom.overview.heading.all": "Alles",
        "teamroom.overview.heading.active": "Actieve rollen",
        "teamroom.overview.heading.paused": "Gepauzeerde rollen",
        "teamroom.overview.heading.concept": "Concepten",
        "teamroom.overview.search": "Zoeken",
        "teamroom.overview.searchPlaceholder": "Zoek op rol, bedrijf of locatie",
        "teamroom.overview.empty.title": "Geen rollen gevonden",
        "teamroom.overview.empty.body": "Pas je zoekopdracht aan om rollen te vinden.",
        "teamroom.overview.empty.clear": "Wissen",

        "teamroom.filter.label": "Filteren op",
        "teamroom.filter.option.all": "Alles",
        "teamroom.filter.option.active": "Actief",
        "teamroom.filter.option.paused": "Gepauzeerd",
        "teamroom.filter.option.concept": "Concept",

        "teamroom.vacancyCard.untitled": "Naamloze rol",
        "teamroom.vacancyCard.updated": "{time} bijgewerkt",
        "teamroom.vacancyCard.fallback": "vacature",

        "teamroom.common.loading": "Laden…",
        "teamroom.common.cancel": "Annuleren",
        "teamroom.common.delete": "Verwijderen",

        "teamroom.candidates.title": "Kandidaten",
        "teamroom.candidates.export": "Exporteer",
        "teamroom.candidates.loading": "Resultaten laden…",
        "teamroom.candidates.empty": "Nog geen kandidaten. Zodra iemand via de sollicitatielink reageert, verschijnt die hier — met Lucy's advies zodra het gesprek is afgerond.",
        "teamroom.candidates.loadError": "De kandidaten konden niet geladen worden — probeer het later opnieuw.",
        "teamroom.candidates.filteredEmpty": "Geen kandidaten binnen de gekozen filters.",
        "teamroom.candidates.col.candidate": "Kandidaat",
        "teamroom.candidates.col.date": "Datum",
        "teamroom.candidates.col.advice": "Advies",
        "teamroom.candidates.rec.proceed": "Aanrader",
        "teamroom.candidates.rec.reject": "Niet door",
        "teamroom.candidates.status.processing": "Analyse",
        "teamroom.candidates.status.notStarted": "Nog niet gestart",
        "teamroom.candidates.status.done": "Afgerond",
        "teamroom.candidates.adviceFilter.all": "Alle adviezen",
        "teamroom.candidates.adviceFilter.pending": "In afwachting",
        "teamroom.candidates.dateFilter.all": "Alles",
        "teamroom.candidates.dateFilter.last7days": "Afgelopen 7 dagen",
        "teamroom.candidates.dateFilter.lastMonth": "Afgelopen maand",
        "teamroom.candidates.dateFilter.period": "Periode",
        "teamroom.candidates.csv.name": "Naam",
        "teamroom.candidates.csv.email": "E-mail",
        "teamroom.candidates.csv.phone": "Telefoonnummer",
        "teamroom.candidates.csv.date": "Datum",
        "teamroom.candidates.csv.advice": "Advies",
        "teamroom.candidates.csv.reason": "Toelichting",
        "teamroom.candidates.csvFileName": "kandidaten",

        "teamroom.vacancy.tab.candidates": "Kandidaten",
        "teamroom.vacancy.tab.interview": "Interview",
        "teamroom.vacancy.tab.settings": "Instellingen",
        "teamroom.vacancy.notFound": "Deze vacature bestaat niet (meer).",
        "teamroom.vacancy.backToOverview": "Terug naar overzicht",
        "teamroom.vacancy.backToLucy": "terug naar Lucy",
        "teamroom.vacancy.ratingScore": "Kandidaten beoordelen dit gesprek met {score}",
        "teamroom.vacancy.ratingCount": "{count} {count, plural, one {beoordeling} other {beoordelingen}}",
        "teamroom.vacancy.ratingTooFew": "Nog te weinig beoordelingen om een score te tonen",
        "teamroom.vacancy.ratingNone": "Nog geen kandidaatbeoordelingen",
        "teamroom.vacancy.actions.testInterview": "Test interview",
        "teamroom.vacancy.actions.share": "Deel sollicitatielink",
        "teamroom.vacancy.actions.more": "Meer acties",
        "teamroom.vacancy.actions.activate": "Rol activeren",
        "teamroom.vacancy.actions.pause": "Rol pauzeren",
        "teamroom.vacancy.actions.delete": "Rol verwijderen",
        "teamroom.vacancy.deleteConfirm.title": "Rol verwijderen?",
        "teamroom.vacancy.deleteConfirm.body": "\"{title}\" wordt uit je actieve rollen gehaald. Je kunt 'm later weer activeren.",

        "teamroom.share.title": "Deel de sollicitatielink",
        "teamroom.share.body": "Zet 'm op je vacature of stuur 'm naar kandidaten — ze starten direct het gesprek met Lucy, zonder account.",
        "teamroom.share.linkLabel": "Sollicitatielink",
        "teamroom.share.copy": "kopieer link",
        "teamroom.share.copied": "gekopieerd!",
        "teamroom.share.openApplyPage": "Open de apply-pagina",
        "teamroom.share.metaAds.title": "Solliciteer via WhatsApp",
        "teamroom.share.metaAds.description": "Plak hier het advertentie-id van je click-to-WhatsApp-advertentie. Kandidaten die via die advertentie appen, krijgen automatisch de link naar het kennismakingsgesprek.",
        "teamroom.share.metaAds.placeholder": "Advertentie-id, meerdere gescheiden door komma's",
        "teamroom.share.metaAds.error": "Dit advertentie-id is al aan een andere vacature gekoppeld.",
        "teamroom.share.metaAds.saveError": "Opslaan lukte niet, probeer het opnieuw.",
        "teamroom.share.metaAds.unlinked.title": "Nog niet gekoppelde advertenties",
        "teamroom.share.metaAds.unlinked.messages": "{count, plural, one {# bericht} other {# berichten}}",
        "teamroom.share.metaAds.unlinked.link": "Koppel aan deze vacature",
        "teamroom.share.metaAds.unlinked.hint": "Tik na het maken of aanpassen van je advertentie één keer zelf op het voorbeeld; het id verschijnt dan hier.",
        "teamroom.share.metaAds.unlinked.linked": "Gekoppeld.",
        "teamroom.share.metaAds.unlinked.linkedWithReplies": "Gekoppeld. {count, plural, one {# kandidaat krijgt} other {# kandidaten krijgen}} alsnog het bericht.",

        "teamroom.candidatePage.headline.proceed": "Lucy raadt aan om door te gaan",
        "teamroom.candidatePage.headline.reject": "Lucy raadt aan om niet door te gaan",
        "teamroom.candidatePage.headline.processing": "Lucy is het gesprek aan het analyseren",
        "teamroom.candidatePage.headline.unavailable": "Geen advies beschikbaar",
        "teamroom.candidatePage.headline.pending": "Nog geen gesprek gevoerd",
        "teamroom.candidatePage.label.unavailable": "Niet beschikbaar",
        "teamroom.candidatePage.fallback.processing": "Het gesprek is afgerond. Lucy werkt aan haar advies — kom later nog even terug.",
        "teamroom.candidatePage.fallback.unavailable": "De analyse kon niet worden afgerond. Het gesprek blijft hieronder beschikbaar.",
        "teamroom.candidatePage.fallback.pending": "Zodra het gesprek met Lucy is gevoerd, verschijnt hier het advies met de motivatie.",
        "teamroom.candidatePage.loadError": "Deze kandidaat kon niet geladen worden.",
        "teamroom.candidatePage.backToVacancy": "Terug naar de vacature",
        "teamroom.candidatePage.vacancyFallback": "Vacature",
        "teamroom.candidatePage.candidateFallback": "Kandidaat",
        "teamroom.candidatePage.copied": "Gekopieerd",
        "teamroom.candidatePage.copyAria": "{value} kopiëren",
        "teamroom.candidatePage.nameCopied": "Naam gekopieerd",
        "teamroom.candidatePage.cv.button": "CV",
        "teamroom.candidatePage.cv.title": "CV van {name}",
        "teamroom.candidatePage.cv.loading": "CV laden…",
        "teamroom.candidatePage.cv.loadError": "Het CV kon niet worden geladen. Probeer het later opnieuw.",
        "teamroom.candidatePage.cv.previewError": "Het CV kon niet worden weergegeven. Je kunt het bestand nog wel downloaden.",
        "teamroom.candidatePage.cv.download": "CV downloaden",
        "teamroom.candidatePage.readMore": "Lees meer",
        "teamroom.candidatePage.readLess": "Lees minder",
        "teamroom.candidatePage.meta.minutes": "{duration} min",
        "teamroom.candidatePage.meta.questions": "{count} vragen",

        "teamroom.transcript.title": "Het gesprek",
        "teamroom.transcript.audioUnavailable": "Audio niet beschikbaar",
        "teamroom.transcript.empty": "Nog geen transcript. Zodra {firstName} het gesprek met Lucy heeft gevoerd, lees je het hier terug.",
        "teamroom.transcript.follow": "Volg het gesprek",
        "teamroom.transcript.unintelligible": "[onverstaanbaar]",

        "teamroom.player.back10": "10 seconden terug",
        "teamroom.player.forward10": "10 seconden vooruit",
        "teamroom.player.play": "Afspelen",
        "teamroom.player.pause": "Pauzeren",

        "teamroom.settings.title": "Instellingen",
        "teamroom.settings.firstName": "Voornaam",
        "teamroom.settings.lastName": "Achternaam",
        "teamroom.settings.changePassword": "Wachtwoord wijzigen",
        "teamroom.settings.passwordUpdated": "Je wachtwoord is bijgewerkt.",
        "teamroom.settings.retry": "Probeer opnieuw",
        "teamroom.settings.verified": "Geverifieerd",
        "teamroom.settings.uploadLogo": "Logo uploaden",
        "teamroom.settings.imageTypeError": "Kies een JPG- of PNG-afbeelding.",
        "teamroom.settings.backgroundHint": "Kies wat kandidaten achter Lucy zien tijdens het interview.",
        "teamroom.settings.companyColor": "Bedrijfskleur",
        "teamroom.settings.backgroundImage": "Afbeelding",
        "teamroom.settings.uploadBackground": "Eigen achtergrond uploaden",
        "teamroom.settings.removeBackground": "Eigen achtergrond verwijderen",
        "teamroom.settings.backgroundFocus": "Focuspunt achtergrond",
        "teamroom.settings.backgroundFocusHint": "Sleep het kader naar het deel van de afbeelding dat op mobiele schermen in beeld moet blijven.",
        "teamroom.settings.tab.account": "Account",
        "teamroom.settings.tab.company": "Bedrijfsinstellingen",
        "teamroom.settings.tab.interview": "Interview",
        "teamroom.settings.tab.integrations": "Integraties",
        "teamroom.settings.tab.users": "Gebruikers",
        "teamroom.settings.name": "Naam",
        "teamroom.settings.email": "E-mail",
        "teamroom.settings.emailChangeHint": "Wil je je e-mailadres wijzigen? {support}",
        "teamroom.settings.emailChangeSupport": "Neem contact op met support",
        "teamroom.settings.mobileNumber": "Mobiel nummer",
        "teamroom.settings.company": "Bedrijf",
        "teamroom.settings.location": "Locatie",
        "teamroom.settings.calendar": "Agenda",
        "teamroom.settings.firstNamePlaceholder": "*Voornaam nog niet ingevuld",
        "teamroom.settings.lastNamePlaceholder": "*Achternaam nog niet ingevuld",
        "teamroom.settings.notSpecifiedPlaceholder": "*Nog niet ingevuld",
        "teamroom.settings.password": "Wachtwoord",
        "teamroom.settings.currentPassword": "Huidig wachtwoord",
        "teamroom.settings.newPassword": "Nieuw wachtwoord",
        "teamroom.settings.repeatNewPassword": "Herhaal nieuw wachtwoord",
        "teamroom.settings.passwordsRequired": "Nieuw wachtwoord en herhaling zijn verplicht",
        "teamroom.settings.passwordsDontMatch": "Wachtwoorden komen niet overeen",
        "teamroom.settings.saveChanges": "Wijzigingen opslaan",
        "teamroom.settings.unsavedChanges": "Je hebt niet-opgeslagen wijzigingen, weet je zeker dat je wilt vertrekken?",
        "teamroom.settings.ok": "OK",
        "teamroom.settings.companySettings": "Interview instellingen",
        "teamroom.settings.interview.preview.desktop": "Desktop",
        "teamroom.settings.interview.preview.mobile": "Mobiel",
        "teamroom.settings.interview.preview.apply": "Sollicitatiepagina",
        "teamroom.settings.interview.preview.caption": "Vertel eens iets over jezelf…",
        "teamroom.settings.companyDescription": "Bedrijfsomschrijving",
        "teamroom.settings.brandColor": "Merkkleur",
        "teamroom.settings.brandColorInvalid": "Voer een kleur in zoals #4598B1.",

        "teamroom.settings.whatsapp": "WhatsApp",
        "teamroom.settings.whatsapp.description": "Koppel de WhatsApp van jullie bedrijf, dan stuurt Lucy kandidaten uit jullie naam de interviewlink en herinneringen.",
        "teamroom.settings.whatsapp.connect": "WhatsApp koppelen",
        "teamroom.settings.whatsapp.connected": "Gekoppeld",
        "teamroom.settings.whatsapp.status.checking": "Status controleren…",
        "teamroom.settings.whatsapp.status.ready": "Klaar om te versturen",
        "teamroom.settings.whatsapp.status.notReady": "Nog niet klaar om te versturen",
        "teamroom.settings.whatsapp.status.waitingForApproval": "Wachten op goedkeuring",
        "teamroom.settings.whatsapp.status.inactive": "Inactief",
        "teamroom.settings.whatsapp.status.unavailable": "Status controleren lukt niet",
        "teamroom.settings.whatsapp.status.refresh": "Status vernieuwen",
        "teamroom.settings.whatsapp.status.retry": "Opnieuw proberen",
        "teamroom.settings.whatsapp.status.displayNameNotApproved": "Meta heeft jullie WhatsApp-weergavenaam nog niet goedgekeurd. Bekijk de status in WhatsApp Manager.",
        "teamroom.settings.whatsapp.status.phoneNumberNotConnected": "Jullie WhatsApp-telefoonnummer is niet verbonden. Bekijk de status in WhatsApp Manager.",
        "teamroom.settings.whatsapp.billingNote": "Meta factureert berichtkosten direct aan jullie bedrijf (± €0,05 per herinnering).",
        "teamroom.settings.whatsapp.reconnect": "Opnieuw koppelen",
        "teamroom.settings.whatsapp.cancelled": "De koppeling is afgebroken voordat deze klaar was.",
        "teamroom.settings.whatsapp.error": "WhatsApp koppelen lukte niet — probeer het opnieuw.",
        "teamroom.settings.whatsapp.templates": "Berichten",
        "teamroom.settings.whatsapp.templates.description": "Deze berichten sturen we automatisch namens jou via WhatsApp.",
        "teamroom.settings.whatsapp.templates.reminder1": "Herinnering 1",
        "teamroom.settings.whatsapp.templates.reminder1.timing": "15 minuten na de sollicitatie",
        "teamroom.settings.whatsapp.templates.reminder2": "Herinnering 2",
        "teamroom.settings.whatsapp.templates.reminder2.timing": "24 uur na de sollicitatie",
        "teamroom.settings.whatsapp.templates.reminder2.toggle": "Herinnering 2 versturen",
        "teamroom.settings.whatsapp.templates.reminder2.toggleError": "De instelling kon niet opgeslagen worden — probeer het opnieuw.",
        "teamroom.settings.whatsapp.templates.status.active": "Actief",
        "teamroom.settings.whatsapp.templates.status.pending": "In beoordeling",
        "teamroom.settings.whatsapp.templates.status.rejected": "Afgekeurd",
        "teamroom.settings.whatsapp.templates.status.paused": "Gepauzeerd",
        "teamroom.settings.whatsapp.templates.refresh": "Status vernieuwen",
        "teamroom.settings.whatsapp.templates.edit": "Bewerken",
        "teamroom.settings.whatsapp.templates.editor.body": "Bericht",
        "teamroom.settings.whatsapp.templates.editor.buttonText": "Knoptekst",
        "teamroom.settings.whatsapp.templates.editor.insert.first_name": "Voornaam",
        "teamroom.settings.whatsapp.templates.editor.insert.vacancy_title": "Vacature",
        "teamroom.settings.whatsapp.templates.editor.insert.company_name": "Bedrijf",
        "teamroom.settings.whatsapp.templates.editor.submit": "Opslaan en ter goedkeuring indienen",
        "teamroom.settings.whatsapp.templates.editor.note": "We blijven de huidige versie versturen tot Meta de nieuwe goedkeurt.",
        "teamroom.settings.whatsapp.templates.editor.error.body_required": "Schrijf eerst een bericht.",
        "teamroom.settings.whatsapp.templates.editor.error.body_too_long": "Het bericht is te lang — maximaal 1024 tekens.",
        "teamroom.settings.whatsapp.templates.editor.error.unknown_field": "Alleen de velden hieronder kun je in het bericht gebruiken.",
        "teamroom.settings.whatsapp.templates.editor.error.field_at_edge": "Het bericht mag niet met een veld beginnen of eindigen.",
        "teamroom.settings.whatsapp.templates.editor.error.adjacent_fields": "Twee velden mogen niet direct na elkaar staan — zet er een woord tussen.",
        "teamroom.settings.whatsapp.templates.editor.error.button_text_required": "Vul de knoptekst in.",
        "teamroom.settings.whatsapp.templates.editor.error.button_text_too_long": "De knoptekst is te lang — maximaal 25 tekens.",
        "teamroom.settings.whatsapp.templates.editor.error.generic": "Opslaan lukte niet — probeer het opnieuw.",
        "teamroom.settings.whatsapp.templates.error": "De berichten konden niet geladen worden — probeer het later opnieuw.",
        "teamroom.settings.interviewBackground": "Interview achtergrond",
        "teamroom.settings.companyLogo": "Bedrijfslogo",
        "teamroom.settings.profileImage": "Profielfoto",
        "teamroom.settings.verify": "Verifieer",
        "teamroom.settings.confirm": "Bevestig",
        "teamroom.settings.verifyCodeInstruction": "Voer de 6-cijferige code in die je hebt ontvangen",
        "teamroom.settings.tooltip.invalidLocation": "Een geldige locatie is verplicht",
        "teamroom.settings.tooltip.invalidPhone": "Een geldig telefoonnummer is verplicht",
        "teamroom.settings.tooltip.changeRequired": "Wijzig eerst iets voordat je opslaat",
        "teamroom.settings.tooltip.companyDescriptionMissing": "Vul eerst de bedrijfsomschrijving in",
        "teamroom.builder.langTab.generating": "Lucy is met dit gesprek bezig…",
        "teamroom.builder.langTab.translating": "Vertalen…",
        "teamroom.builder.langTab.translateError": "Het vertalen van dit gesprek lukte niet. Probeer het opnieuw, of bouw het hieronder zelf op.",
        "teamroom.builder.langTab.retry": "Probeer opnieuw",
        "teamroom.builder.langTab.unsaved": "Sla je wijzigingen op of maak ze ongedaan voordat je van taal wisselt.",
        "teamroom.builder.langTab.notGenerated": "Dit gesprek bestaat nog niet in deze taal. Bouw het hieronder zelf op, of laat Lucy de vragen vertalen vanuit je bestaande gesprek.",
        "teamroom.builder.langTab.generateButton": "Laat Lucy het vertalen",
        "teamroom.builder.loadFailed": "Het gesprek kon niet worden geladen. Probeer het nog eens.",

        "teamroom.settings.language": "Taal",

        "teamroom.builder.loading": "Het gesprek laden…",
        "teamroom.builder.saveFailed": "Je wijzigingen konden niet worden opgeslagen. Probeer het nog eens.",
        "teamroom.builder.validationModal.title": "Gesprek nog niet compleet",
        "teamroom.builder.validationModal.continueEditing": "Verder bewerken",
        "teamroom.builder.heading": "Het gesprek",
        "teamroom.builder.status.saved": "opgeslagen",
        "teamroom.builder.status.lucyUpdated": "Lucy is bijgewerkt",
        "teamroom.builder.status.saving": "bezig met opslaan…",
        "teamroom.builder.status.unsaved": "nog niet opgeslagen",
        "teamroom.builder.undo": "Ongedaan",
        "teamroom.builder.edit": "Bewerk",
        "teamroom.builder.done": "Klaar",
        "teamroom.builder.publishUpdates": "Zet updates live",
        "teamroom.builder.addSection": "Sectie toevoegen",
        "teamroom.builder.sectionType.text": "Tekst",
        "teamroom.builder.sectionType.questions": "Vragen",
        "teamroom.builder.fixed": "vast",
        "teamroom.builder.greetingPreview": "Hi [NAAM KANDIDAAT].",
        "teamroom.builder.empty.title": "Laten we het gesprek opbouwen",
        "teamroom.builder.empty.body": "Begin met een intro, voeg je vragen toe en sluit warm af.",
        "teamroom.builder.guard.title": "Wijzigingen opslaan?",
        "teamroom.builder.guard.body": "Je hebt wijzigingen klaarstaan die nog niet live zijn. Sla ze op voordat je verdergaat, of ga door zonder op te slaan.",
        "teamroom.builder.guard.keepEditing": "Blijf bewerken",
        "teamroom.builder.guard.discard": "Niet opslaan",
        "teamroom.builder.guard.save": "Opslaan",
        "teamroom.builder.validation.noSections": "Voeg minstens één sectie toe voordat je de wijzigingen live zet.",
        "teamroom.builder.validation.titleRequired": "Iedere sectie heeft een titel nodig.",
        "teamroom.builder.validation.questionRequired": "Een vraag is verplicht bij iedere tekstsectie waar nog een sectie op volgt, zodat de kandidaat een duidelijk moment heeft om te reageren.",
        "teamroom.builder.validation.contentRequired": "Vul iedere sectie inhoudelijk in.",
        "teamroom.builder.nav.title": "In dit gesprek",
        "teamroom.builder.nav.textSection": "Tekstsectie",
        "teamroom.builder.nav.questionBlock": "Vragenblok",
        "teamroom.builder.questionPlaceholder": "Formuleer hier de vraag…",
        "teamroom.builder.moveUp": "Omhoog",
        "teamroom.builder.moveDown": "Omlaag",
        "teamroom.builder.deleteQuestion": "Vraag verwijderen",
        "teamroom.builder.deleteSection": "Sectie verwijderen",
        "teamroom.builder.generating.title": "Lucy stelt je gesprek samen…",
        "teamroom.builder.generating.phase1": "De vacaturetekst lezen…",
        "teamroom.builder.generating.phase2": "Competenties bepalen…",
        "teamroom.builder.generating.phase3": "Vragen bedenken…",
        "teamroom.builder.generating.phase4": "Het gesprek opbouwen…",
        "teamroom.builder.condition.ask.label": "Alleen vragen als…",
        "teamroom.builder.condition.ask.placeholder": "Bijv. alleen als de kandidaat ervaring met Zendesk noemt",
        "teamroom.builder.condition.skip.label": "Overslaan als…",
        "teamroom.builder.condition.skip.placeholder": "Bijv. niet woonachtig in NL",
        "teamroom.builder.setup.short.label": "Kort gesprek",
        "teamroom.builder.setup.short.desc": "Een vlotte kennismaking — een paar kerngerichte vragen.",
        "teamroom.builder.setup.long.label": "Uitgebreid gesprek",
        "teamroom.builder.setup.long.desc": "Een grondig gesprek — meer vragen met natuurlijke doorvragen.",
        "teamroom.builder.setup.aiQuestions": "Vragen door AI",
        "teamroom.builder.setup.blank.label": "Of begin met een blanco opzet",
        "teamroom.builder.setup.blank.desc": "Start leeg en bouw de intro + vragen zelf.",
        "teamroom.builder.section.titlePlaceholder.content": "Titel van deze sectie",
        "teamroom.builder.section.titlePlaceholder.questions": "Naam van dit blok",
        "teamroom.builder.section.titleRequired": "Een sectietitel is verplicht",
        "teamroom.builder.section.textPlaceholder": "Schrijf hier wat Lucy letterlijk zegt…",
        "teamroom.builder.section.addQuestion": "Vraag toevoegen",
        "teamroom.builder.section.addOptionalQuestion": "Optionele vraag toevoegen",
        "teamroom.builder.section.questionRequired": "Een vraag is verplicht, zodat de kandidaat een duidelijk moment heeft om te reageren",
        "teamroom.builder.section.questionPlaceholder": "Eén vraag bij deze sectie…",
        "teamroom.builder.section.removeQuestion": "Vraag weghalen",
        "teamroom.builder.tree.empty": "Nog geen vragen. Voeg je eerste hoofdvraag toe.",
        "teamroom.builder.tree.addMain": "Hoofdvraag toevoegen",
        "teamroom.builder.tree.addSub": "Subvraag toevoegen",
        "teamroom.vacancyForm.jobTitle": "Functietitel",
        "teamroom.vacancyForm.jobTitlePlaceholder": "bijv. Klantenservice Medewerker",
        "teamroom.vacancyForm.companyName": "Bedrijfsnaam",
        "teamroom.vacancyForm.companyNamePlaceholder": "bijv. welovehumans",
        "teamroom.vacancyForm.location": "Locatie",
        "teamroom.vacancyForm.interviewLanguage": "Taal van gesprek",
        "teamroom.vacancyForm.additionalLanguages": "Andere talen",
        "teamroom.vacancyForm.noAdditionalLanguage": "Geen extra taal",
        "teamroom.vacancyForm.jobDescription": "Vacaturetekst",
        "teamroom.vacancyForm.language.nl": "Nederlands",
        "teamroom.vacancyForm.language.en": "Engels",
        "teamroom.vacancySettings.title": "Vacature",
        "teamroom.vacancySettings.edit": "Bewerk",
        "teamroom.vacancySettings.editTitle": "Vacature bewerken",
        "teamroom.vacancySettings.country": "Land",
        "teamroom.vacancySettings.save": "Opslaan",
        "teamroom.vacancySettings.saveError": "Opslaan lukte niet — probeer het zo nog eens.",

        "teamroom.wizard.step.infer.bubble": "waar train je me op?",
        "teamroom.wizard.step.validate.bubble": "klopt dit zo?",
        "teamroom.wizard.step.generate.bubble": "nu het gesprek!",
        "teamroom.wizard.nav.next": "Volgende",
        "teamroom.wizard.nav.back": "Terug",
        "teamroom.wizard.nav.generate": "Genereer vragen",
        "teamroom.wizard.nav.startTraining": "Start training",
        "teamroom.wizard.stepCount": "Stap {current} van {total}",
        "teamroom.wizard.loadingConcept": "Je concept laden…",
        "teamroom.wizard.deleteConcept.title": "Concept verwijderen?",
        "teamroom.wizard.deleteConcept.body": "\"{title}\" wordt uit je concepten gehaald.",
        "teamroom.wizard.deleteConcept.action": "Concept verwijderen",
        "teamroom.wizard.infer.title": "Waarop train ik?",
        "teamroom.wizard.infer.intro": "Geef me de vacature — een link, de tekst, of een bestand. De rest vul ik zelf in.",
        "teamroom.wizard.infer.phase.reading": "De vacaturetekst lezen…",
        "teamroom.wizard.infer.phase.filling": "De gegevens invullen…",
        "teamroom.wizard.infer.phase.saving": "Je concept opslaan…",
        "teamroom.wizard.infer.error": "Dat lukte niet — controleer de link of plak de tekst, en probeer opnieuw.",
        "teamroom.wizard.validate.title": "Dit hebben we gevonden",
        "teamroom.wizard.validate.intro": "Check het even en vul aan waar nodig.",
        "teamroom.wizard.validate.saveError": "Er ging iets mis bij het opslaan — probeer het zo nog eens.",
        "teamroom.wizard.generate.title": "Wat voor gesprek wordt het?",
        "teamroom.wizard.generate.intro": "Kies een opzet — Lucy schrijft de vragen met AI, op maat van jouw vacature.",
        "teamroom.wizard.generate.error": "Het genereren lukte niet — probeer het zo nog eens.",
        "teamroom.wizard.source.tab.url": "Link",
        "teamroom.wizard.source.tab.file": "Bestand",
        "teamroom.wizard.source.tab.text": "Tekst",
        "teamroom.wizard.source.urlPlaceholder": "https://jouwbedrijf.nl/vacatures/...",
        "teamroom.wizard.source.urlHint": "Plak de link naar de vacature — ik haal de tekst er zelf uit.",
        "teamroom.wizard.source.textPlaceholder": "Plak of typ de vacaturetekst — wat ga je doen, welke vaardigheden zijn belangrijk?",
        "teamroom.wizard.source.removeFile": "Verwijder bestand",
        "teamroom.wizard.source.drop": "Sleep je document hierheen of {browse}",
        "teamroom.wizard.source.browse": "blader",
        "teamroom.wizard.source.fileTypes": "PDF of Word (.pdf, .docx)",
        "teamroom.wizard.source.fileTypeError": "Upload een PDF- of Word-bestand (.pdf of .docx).",
        "teamroom.wizard.alwaysOn.title": "24/7 — altijd beschikbaar",
        "teamroom.wizard.alwaysOn.subtitle": "Lucy neemt dag en nacht gesprekken af.",
        "teamroom.wizard.alwaysOn.statusOn": "Lucy is ingeschakeld — ze pakt elk gesprek, dag en nacht.",
        "teamroom.wizard.alwaysOn.statusOff": "Lucy staat te trappelen om te beginnen — geef 'r het sein.",
        "teamroom.wizard.completion.title.on": "Lucy staat 24/7 aan",
        "teamroom.wizard.completion.title.off": "Lucy is getraind, zet haar aan",
        "teamroom.wizard.completion.subtitle.on": "Deel de link en de gesprekken stromen binnen.",
        "teamroom.wizard.completion.subtitle.off": "Eén tik en ze gaat dag en nacht voor je aan de slag.",
        "teamroom.wizard.completion.activateError": "Activeren lukte niet — probeer het zo nog eens.",
        "teamroom.wizard.completion.copy": "Kopieer",
        "teamroom.wizard.completion.copied": "Gekopieerd",
        "teamroom.wizard.completion.toInterviewPage": "Naar interview pagina",
        "teamroom.wizard.training.phase1": "Lucy trainen…",
        "teamroom.wizard.training.phase2": "Het gesprek instellen…",
        "teamroom.wizard.training.phase3": "De vragen inladen…",
        "teamroom.wizard.training.phase4": "Bijna klaar…",
        "teamroom.createVacancy.cityPlaceholder": "bijv. Amsterdam",
        "teamroom.createVacancy.jobDescriptionPlaceholder": "Plak hier de vacaturetekst, zodat je 'm bij de hand hebt tijdens het opbouwen van het gesprek.",
    }
}

export default TEAMROOM_LOCALE_TEMPLATES;
